import { forgetPasswordUrl, requestJson, NEED_CAPTCHA_CODE, NEED_SECOND_CAPTCHA_CODE, gaiaKey } from './config'
import { getConstId, handleResponse } from './utils'
import { myAxios } from '../utils'
const forgetPasswordSendUrl = `${forgetPasswordUrl}/send` // 忘记密码时请求短信
const submitForgetPasswordSmsUrl = `${forgetPasswordUrl}/sms` // 忘记密码时输入短信验验证码
const setForgetPasswordUrl = `${forgetPasswordUrl}/set` // 忘记密码时重设密码

/*
* 忘记密码-发送短信验证码
*  */
export const forgetPasswordSend = async (params) => {
  const fingerprint = await getConstId()
  // eslint-disable-next-line camelcase
  const { channel, bu_code } = await requestJson()
  let paramsData = {
    bu_code,
    channel,
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(forgetPasswordSendUrl, paramsData, {
    loading: false, // 禁用loading
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res, [ NEED_CAPTCHA_CODE, NEED_SECOND_CAPTCHA_CODE ])
    })
}

/*
* 忘记密码-提交短信验证码
*  */
export const submitForgetPasswordSms = async (params) => {
  const fingerprint = await getConstId()
  // eslint-disable-next-line camelcase
  const { channel, bu_code } = await requestJson()
  let paramsData = {
    channel,
    bu_code,
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(submitForgetPasswordSmsUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 忘记密码-设置密码
*  */
export const setForgetPassword = async (params) => {
  const fingerprint = await getConstId()
  // eslint-disable-next-line camelcase
  const { channel, bu_code } = await requestJson()
  let paramsData = {
    channel,
    bu_code,
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(setForgetPasswordUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}
